export default "__VITE_ASSET__Bmoueh9Y__"